import React from 'react';
import { Link as SPALink } from '@atlassian/react-resource-router/src/Link.tsx';

type Props = {
	name: string;
	issuesUrl: string;
};

export default function ComponentView(props: Props) {
	const { name, issuesUrl } = props;

	return (
		<SPALink
			href={issuesUrl}
			data-testid="project-directories.components.table.cell.component.link"
		>
			{name}
		</SPALink>
	);
}
